/**
 * Global Legal Footer — appears on every page.
 *
 * Required by EU "imprint" rule (Impressumspflicht) and good practice in
 * the US. Lists LLC name, state of registration, contact, and links to all
 * legal docs. Tiny, unobtrusive, always visible.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import './LegalFooter.css';

export const LegalFooter = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  return (
    <footer className="legal-footer" data-testid="legal-footer">
      <div className="lf-inner">
        <div className="lf-entity">
          <strong>A-1 Affiliate Marketing LLC</strong>
          <span className="lf-sep">·</span>
          <span>Registered in Kansas, USA</span>
          <span className="lf-sep">·</span>
          <span data-testid="lf-mailing-address">PO Box 2, Atchison, KS 66002</span>
          <span className="lf-sep">·</span>
          <a href="mailto:a1affiliatemarketingllc@gmail.com">a1affiliatemarketingllc@gmail.com</a>
        </div>
        <nav className="lf-links" aria-label="Legal">
          <a href="/terms" data-testid="lf-terms">{t('footer.terms', 'Terms')}</a>
          <span className="lf-sep">·</span>
          <a href="/privacy" data-testid="lf-privacy">{t('footer.privacy', 'Privacy')}</a>
          <span className="lf-sep">·</span>
          <a href="/refund" data-testid="lf-refund">{t('footer.refund', 'Refund')}</a>
          <span className="lf-sep">·</span>
          <a href="/disclaimer" data-testid="lf-disclaimer">{t('footer.disclaimer', 'Disclaimer')}</a>
          <span className="lf-sep">·</span>
          <a href="/dmca" data-testid="lf-dmca">{t('footer.dmca', 'DMCA')}</a>
          <span className="lf-sep">·</span>
          <a href="/third-party-notices.txt">Third-party notices</a>
        </nav>
        <section className="lf-more" aria-labelledby="lf-more-heading">
          <h2 id="lf-more-heading">More from A-1 Affiliate Marketing LLC</h2>
          <a href="https://veteranclaimaid.life">VeteranClaimAid</a>
          <p>VeteranClaimAid - organization and information tools for veterans researching their benefits.</p>
          <p>SuperBrain and VeteranClaimAid are sister products from the same company, A-1 Affiliate Marketing LLC.</p>
        </section>
        <div className="lf-rights">
          © {year} A-1 Affiliate Marketing LLC — All Rights Reserved
          <div>Not affiliated with any government agency, AI company or search engine.</div>
        </div>
      </div>
    </footer>
  );
};

export default LegalFooter;
